import Main from '@/views/main/main.vue';
import dept from './dept';
import user from './user';
import post from './post';
import role from './role';
import menu from './menu';

export default {
    path: '/organization',
    name: 'organization',
    meta: {icon: 'md-git-network'},
    component: Main,
    children: [...dept, ...user, ...post, ...role, ...menu],
};
